
import React from 'react';
import { config } from "util/config";

const CustomStatistic = ({
  title,
  text,
  color = '#ffffff',
  backgroundImage = 'linear-gradient(-20deg, #a20000 0%, #cd0000 100%)',
  titleFontSize = '18px',
  textFontSize = '25px',
  lineHeight = '25px',
  padding = '10px',
  margin = '0',
  borderRadius = '0.25rem',
  backgroundColor = null,
}) =>
  <div className='custom-statistic-span' style={{
    color: color,
    backgroundImage: backgroundImage,
    backgroundColor: backgroundColor,
    padding: padding,
    margin: margin,
    borderRadius: borderRadius,
    display: 'inline-flex',
    width: '-webkit-fill-available',
    cursor: 'pointer'
  }}>
    <div style={{ fontSize: titleFontSize, lineHeight: lineHeight, width: '60%', verticalAlign: 'text-bottom' }}>{title}</div>
    <div style={{ fontSize: textFontSize, lineHeight: lineHeight, width: '40%', textAlign: 'right' }}>{text}</div>
  </div>;
export default CustomStatistic;
